/** Official product words. New screens should use these instead of "Item". */
export const STTerminology = {
  challenge: "Challenge",
  challenges: "Challenges",
  challengePack: "Challenge Pack",
  challengePacks: "Challenge Packs",
  challengeLibrary: "Challenge Library",
  addChallenge: "Add Challenge",
  addChallengePack: "Add Challenge Pack",
  updateChallenge: "Update Challenge",
  deleteChallenge: "Delete Challenge",
  chooseChallenges: "Choose Challenges",
  myChallenges: "My Challenges",
  challengeName: "Challenge Name",
  challengeLimit: "Challenge Limit",
};

export const challengeLabel = (count) =>
  Number(count) === 1 ? STTerminology.challenge : STTerminology.challenges;
